<template>
  <div class="profile-shop-banners mb-8 w-full overflow-hidden">
    <IAICarousel
      v-if="props.banners.length > 0"
      variant="secondary"
      indicators-position="inside"
      :value="props.banners"
      :num-visible="1"
      :num-scroll="1"
      hide-nav-buttons
      :circular="props.banners.length > 1"
      :hide-indicators="props.banners.length === 1"
    >
      <template #item="slotProps: { data: ProfileShopBanner }">
        <div class="group relative flex w-full justify-center overflow-hidden rounded-lg">
          <Component
            :is="slotProps.data.link_url ? 'a' : 'div'"
            v-bind="slotProps.data.link_url ? linkProps(slotProps.data) : {}"
            class="relative inline-block w-full"
          >
            <img :src="getImageSrc(slotProps.data)" :alt="slotProps.data.campaign_name" class="h-auto w-full" />
          </Component>
        </div>
      </template>
    </IAICarousel>
  </div>
</template>

<script setup lang="ts">
import { IAICarousel } from "@/core-ui-vue";
import { ProfileShopBanner } from "@/features/profile-shop/services/api";
import { funnelService } from "@/services/funnelService";
import { universalStorage } from "@/utils/universal-storage";

const props = defineProps<{
  banners: ProfileShopBanner[];
}>();

const mobile_or_desktop = universalStorage.get("mobile_or_desktop");
const linkProps = (banner: ProfileShopBanner) => ({
  href: addBannerParams(banner.link_url || ""),
  target: "_blank",
  rel: "noopener noreferrer",
  onClick: (e: Event) => {
    funnelService.trackEvent("profile_shop_banner_clicked", {
      campaign_name: banner.campaign_name,
      link: banner.link_url || "",
    });
  },
});

const getImageSrc = (banner: ProfileShopBanner) => banner.image_url[mobile_or_desktop || "desktop"];

const addBannerParams = (url: string) => {
  const urlObj = new URL(url);
  urlObj.searchParams.set("source", "banner");
  return urlObj.toString();
};
</script>
